import React, { Component } from 'react';
import { array, arrayOf, func, node, number, object, oneOf, string } from 'prop-types';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';
import { parseSelectFilterOptions } from '../../../util/search';
import { SCHEMA_TYPE_ENUM, SCHEMA_TYPE_MULTI_ENUM } from '../../../util/types';

import { FieldCheckbox } from '../../../components';

import FilterPlain from '../FilterPlain/FilterPlain';
import FilterPopup from '../FilterPopup/FilterPopup';

import css from './SelectMultipleFilter.module.css';

const whitheSquare = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082879/socialbnb/assets/whithSquare.webp';



const tour = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082632/socialbnb/assets/icons/surroundings/Touranbieter.png';





















































const supermarket = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082630/socialbnb/assets/icons/surroundings/Supermarket.png';

const restaurant = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082628/socialbnb/assets/icons/surroundings/Restaurant.png';

const facility = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082626/socialbnb/assets/icons/surroundings/Doctor.png';

const bank = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082625/socialbnb/assets/icons/surroundings/Bank.png';

const twobedroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082614/socialbnb/assets/icons/roomtypes/twobedroom.png';

const shared_bedroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082613/socialbnb/assets/icons/roomtypes/shared_bedroom.png';

const singlebedroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082613/socialbnb/assets/icons/roomtypes/onebedroom.png';

const multi_bedroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082612/socialbnb/assets/icons/roomtypes/multi_bedroom.png';

const entire_accomodation = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082610/socialbnb/assets/icons/roomtypes/entire_accomodation.png';

const doublebedroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082609/socialbnb/assets/icons/roomtypes/doublebedroom.png';

const tent = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082608/socialbnb/assets/icons/roomtypes/camping.png';

const vegetarian_options = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082599/socialbnb/assets/icons/meals/Vegetarian_.webp';
















const vegan_options = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082598/socialbnb/assets/icons/meals/Vegan.webp';


const lunch_inclusive = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082597/socialbnb/assets/icons/meals/Lunch.webp';

const lunch_for_sale = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082596/socialbnb/assets/icons/meals/Lunch-paid.webp';

const coffee_tee = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082595/socialbnb/assets/icons/meals/Coffee_.webp';


const breakfast_inclusive = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082594/socialbnb/assets/icons/meals/Breakfast.webp';

const breakfast_for_sale = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082593/socialbnb/assets/icons/meals/Breakfast-paid.webp';

const dinner_inclusive = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082592/socialbnb/assets/icons/meals/Abendessen.webp';

const dinner_for_sale = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082592/socialbnb/assets/icons/meals/Abendessen-paid.webp';

const internet = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082564/socialbnb/assets/icons/equipment/Wifi.webp';

const washing = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082564/socialbnb/assets/icons/equipment/Waschk_che_.webp';

const laundry_facilities = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082564/socialbnb/assets/icons/equipment/Waschk_che_.webp';

const fan = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082562/socialbnb/assets/icons/equipment/Ventilator_.webp';

const tv = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082562/socialbnb/assets/icons/equipment/Tv.webp';

const toilet = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082561/socialbnb/assets/icons/equipment/Toilet.webp';

const sink = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082561/socialbnb/assets/icons/equipment/Sink.webp';

const shower = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082560/socialbnb/assets/icons/equipment/Shower.webp';

const shared_kitchen = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082559/socialbnb/assets/icons/equipment/SharedKitchen.webp';

const safe = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082559/socialbnb/assets/icons/equipment/Security_Locker.webp';

const parking = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082557/socialbnb/assets/icons/equipment/Parking.webp';

const mosquito_net = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082556/socialbnb/assets/icons/equipment/Moskito.webp';

const luggage_storage = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082556/socialbnb/assets/icons/equipment/Luggage.webp';

const light = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082555/socialbnb/assets/icons/equipment/Lampe.webp';

const air_conditioning = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082554/socialbnb/assets/icons/equipment/Klimaanlage.webp';

const private_kitchen = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082553/socialbnb/assets/icons/equipment/Kitchen.webp';

const heating = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082553/socialbnb/assets/icons/equipment/Heater.webp';

const towels = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082549/socialbnb/assets/icons/equipment/Handt_cher_.webp';

const electricity = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082548/socialbnb/assets/icons/equipment/Electricity.webp';

const wardrobe = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082547/socialbnb/assets/icons/equipment/Dresser.webp';

const computer = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082546/socialbnb/assets/icons/equipment/Computer.webp';

const bedsheets = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082546/socialbnb/assets/icons/equipment/Bettw_sche_.webp';

const privat_bathroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082545/socialbnb/assets/icons/equipment/Bathroom.webp';

const shared_bathroom = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082544/socialbnb/assets/icons/equipment/Bathroom-Shared.webp';

const trekking = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082539/socialbnb/assets/icons/characteristics/Trekking.webp';

const culture = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082537/socialbnb/assets/icons/characteristics/Theatre.webp';

const sportlovers = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082536/socialbnb/assets/icons/characteristics/Sport.webp';

const projecttours_impossible = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082535/socialbnb/assets/icons/characteristics/Projektbesuch_Cancel.webp';

const projecttours_possible = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082534/socialbnb/assets/icons/characteristics/Projektbesuch_.webp';

const nature = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082534/socialbnb/assets/icons/characteristics/Nature.webp';

const comfort = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082531/socialbnb/assets/icons/characteristics/Komfort.webp';

const familyfriendly = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082529/socialbnb/assets/icons/characteristics/Family.webp';

const accessibility = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082529/socialbnb/assets/icons/characteristics/Bus.webp';

const near_beach = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082528/socialbnb/assets/icons/characteristics/Beach.webp';

const barrier_free = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082527/socialbnb/assets/icons/characteristics/barrierefreiheit.webp';

const animallovers = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082524/socialbnb/assets/icons/characteristics/Animals.webp';

const adventure = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082523/socialbnb/assets/icons/characteristics/adventure.webp';

const Sports = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082369/socialbnb/assets/categories/sports.webp';

const Health = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082368/socialbnb/assets/categories/health.webp';

const Equality = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082367/socialbnb/assets/categories/equality.webp';

const Naturschutz = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082367/socialbnb/assets/categories/environment.webp';

const Bildung = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082366/socialbnb/assets/categories/education.webp';

const Tierschutz = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082365/socialbnb/assets/categories/animal.webp';

// SelectMultipleFilter doesn't need array mutators since it doesn't require validation.
// TODO: Live edit didn't work with FieldCheckboxGroup
//       There's a mutation problem: formstate.dirty is not reliable with it.

const optionImageMap = {
  'B&B': whitheSquare,
  glamping: whitheSquare,
  hostel: whitheSquare,
  hotel: whitheSquare,
  homestay: whitheSquare,
  holiday: whitheSquare,
  apartment: whitheSquare,
  tinyHouse: whitheSquare,
  camping: whitheSquare,
  banglow: whitheSquare,
  boat: whitheSquare,

  singlebedroom: singlebedroom,
  doublebedroom: doublebedroom,
  twobedroom: twobedroom,
  shared_bedroom: shared_bedroom,
  multi_bedroom: multi_bedroom,
  entire_accomodation: entire_accomodation,
  tent: tent,

  comfort: comfort,
  adventure: adventure,
  nature: nature,
  near_beach: near_beach,
  animallovers: animallovers,
  sportlovers: sportlovers,
  familyfriendly: familyfriendly,
  trekking: trekking,
  culture: culture,
  barrier_free: barrier_free,
  accessibility: accessibility,
  projecttours_possible: projecttours_possible,
  projecttours_impossible: projecttours_impossible,

  light: light,
  electricity: electricity,
  bedsheets: bedsheets,
  sink: sink,
  shower: shower,
  toilet: toilet,
  privat_bathroom: privat_bathroom,
  shared_bathroom: shared_bathroom,
  private_kitchen: private_kitchen,
  shared_kitchen: shared_kitchen,
  internet: internet,
  computer: computer,
  tv: tv,
  mosquito_net: mosquito_net,
  towels: towels,
  fan: fan,
  air_conditioning: air_conditioning,
  heating: heating,
  safe: safe,
  wardrobe: wardrobe,
  parking: parking,
  luggage_storage: luggage_storage,
  laundry_facilities: laundry_facilities,

  supermarket: supermarket,
  restaurant: restaurant,
  facility: facility,
  washing: washing,
  bank: bank,
  public_transport: accessibility,
  tour: tour,

  english: whitheSquare,
  spanish: whitheSquare,
  french: whitheSquare,
  german: whitheSquare,
  portuguese: whitheSquare,
  chinese: whitheSquare,

  Bildung: Bildung,
  Naturschutz: Naturschutz,
  Tierschutz: Tierschutz,
  Equality: Equality,
  Health: Health,
  Sports: Sports,

  Dollar: whitheSquare,
  Euro: whitheSquare,

  breakfast_inclusive: breakfast_inclusive,
  breakfast_for_sale: breakfast_for_sale,
  lunch_inclusive: lunch_inclusive,
  lunch_for_sale: lunch_for_sale,
  dinner_inclusive: dinner_inclusive,
  dinner_for_sale: dinner_for_sale,
  vegetarian_options: vegetarian_options,
  vegan_options: vegan_options,
  coffee_tee: coffee_tee,

  // ... and so on for other options
};
const GroupOfFieldCheckboxes = props => {
  const { id, className, name, options } = props;
  return (
    <fieldset className={className}>
      <ul className={css.list}>
        {options.map((option, index) => {
          const fieldId = `${id}.${option.key}`;
          return (
            <li key={fieldId} className={css.item}>
              <FieldCheckbox
                id={fieldId}
                icon={optionImageMap[option.key]}
                name={name}
                label={option.label}
                value={option.key}
              />
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
};

const getQueryParamName = queryParamNames => {
  return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
};

// Format URI component's query param: { pub_key: 'has_all:a,b,c' }
const format = (selectedOptions, queryParamName, schemaType, searchMode) => {
  const hasOptionsSelected = selectedOptions && selectedOptions.length > 0;
  const mode = schemaType === SCHEMA_TYPE_MULTI_ENUM && searchMode ? `${searchMode}:` : '';
  const value = hasOptionsSelected ? `${mode}${selectedOptions.join(',')}` : null;
  return { [queryParamName]: value };
};

class SelectMultipleFilter extends Component {
  constructor(props) {
    super(props);

    this.filter = null;
    this.filterContent = null;

    this.positionStyleForContent = this.positionStyleForContent.bind(this);
  }

  positionStyleForContent() {
    if (this.filter && this.filterContent) {
      // Render the filter content to the right from the menu
      // unless there's no space in which case it is rendered
      // to the left
      const distanceToRight = window.innerWidth - this.filter.getBoundingClientRect().right;
      const labelWidth = this.filter.offsetWidth;
      const contentWidth = this.filterContent.offsetWidth;
      const contentWidthBiggerThanLabel = contentWidth - labelWidth;
      const renderToRight = distanceToRight > contentWidthBiggerThanLabel;
      const contentPlacementOffset = this.props.contentPlacementOffset;

      const offset = renderToRight
        ? { left: contentPlacementOffset }
        : { right: contentPlacementOffset };
      // set a min-width if the content is narrower than the label
      const minWidth = contentWidth < labelWidth ? { minWidth: labelWidth } : null;

      return { ...offset, ...minWidth };
    }
    return {};
  }

  render() {
    const {
      rootClassName,
      className,
      id,
      name,
      label,
      options,
      initialValues,
      contentPlacementOffset,
      onSubmit,
      queryParamNames,
      schemaType,
      searchMode,
      intl,
      showAsPopup,
      ...rest
    } = this.props;

    const classes = classNames(rootClassName || css.root, className);

    const queryParamName = getQueryParamName(queryParamNames);
    const hasInitialValues = !!initialValues && !!initialValues[queryParamName];
    // Parse options from param strings like "has_all:a,b,c" or "a,b,c"
    const selectedOptions = hasInitialValues
      ? parseSelectFilterOptions(initialValues[queryParamName])
      : [];

    const labelForPopup = hasInitialValues
      ? intl.formatMessage(
          { id: 'SelectMultipleFilter.labelSelected' },
          { labelText: label, count: selectedOptions.length }
        )
      : label;

    const labelSelectionForPlain = hasInitialValues
      ? intl.formatMessage(
          { id: 'SelectMultipleFilterPlainForm.labelSelected' },
          { count: selectedOptions.length }
        )
      : '';

    const contentStyle = this.positionStyleForContent();

    // pass the initial values with the name key so that
    // they can be passed to the correct field
    const namedInitialValues = { [name]: selectedOptions };

    const handleSubmit = values => {
      const usedValue = values ? values[name] : values;
      onSubmit(format(usedValue, queryParamName, schemaType, searchMode));
    };

    return showAsPopup ? (
      <FilterPopup
        className={classes}
        rootClassName={rootClassName}
        popupClassName={css.popupSize}
        name={name}
        label={labelForPopup}
        isSelected={hasInitialValues}
        id={`${id}.popup`}
        showAsPopup
        contentPlacementOffset={contentPlacementOffset}
        onSubmit={handleSubmit}
        initialValues={namedInitialValues}
        keepDirtyOnReinitialize
        {...rest}
      >
        <GroupOfFieldCheckboxes
          className={css.fieldGroup}
          name={name}
          id={`${id}-checkbox-group`}
          options={options}
        />
      </FilterPopup>
    ) : (
      <FilterPlain
        className={className}
        rootClassName={rootClassName}
        label={label}
        labelSelection={labelSelectionForPlain}
        isSelected={hasInitialValues}
        id={`${id}.plain`}
        liveEdit
        contentPlacementOffset={contentStyle}
        onSubmit={handleSubmit}
        initialValues={namedInitialValues}
        {...rest}
      >
        <GroupOfFieldCheckboxes
          className={css.fieldGroupPlain}
          name={name}
          id={`${id}-checkbox-group`}
          options={options}
        />
      </FilterPlain>
    );
  }
}

SelectMultipleFilter.defaultProps = {
  rootClassName: null,
  className: null,
  initialValues: null,
  contentPlacementOffset: 0,
  searchMode: null,
};

SelectMultipleFilter.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  name: string.isRequired,
  queryParamNames: arrayOf(string).isRequired,
  label: node.isRequired,
  onSubmit: func.isRequired,
  options: array.isRequired,
  searchMode: oneOf(['has_all', 'has_any']),
  schemaType: oneOf([SCHEMA_TYPE_ENUM, SCHEMA_TYPE_MULTI_ENUM]).isRequired,
  initialValues: object,
  contentPlacementOffset: number,

  // form injectIntl
  intl: intlShape.isRequired,
};

export default injectIntl(SelectMultipleFilter);
